// Connects library domain state to the shared library layout shell.

import React from 'react';
import { Outlet } from 'react-router';
import LibraryLayout from '../../layouts/LibraryLayout';
import AchievementDialog from './achievements/AchievementDialog';
import { DialogOutlet } from './dialogs';
import LibrarySidebar from './Sidebar';
import MaintenanceBanner from './MaintenanceBanner';
import { useLibraryLayoutState } from './hooks';

const LibraryRoute: React.FC = () => {
  const {
    user,
    pathname,
    panel,
    dialog,
    playerAccess,
    censorship,
    poppyChat,
    connectionsTwitchError,
    setPanel,
    setDialog,
    openDialog,
    authStep,
    setAuthStep,
    mobileTitle,
  } = useLibraryLayoutState();

  return (
    <LibraryLayout
      announcement={<MaintenanceBanner />}
      mobileTitle={mobileTitle}
      sidebar={
        <LibrarySidebar
          user={user}
          pathname={pathname}
          panel={panel}
          dialog={dialog}
          playerAccess={playerAccess}
          censorship={censorship}
          poppyChat={poppyChat}
          setPanel={setPanel}
          openDialog={openDialog}
        />
      }
      dialogs={
        <>
          <DialogOutlet
            user={user}
            dialog={dialog}
            playerAccess={playerAccess}
            censorship={censorship}
            connectionsTwitchError={connectionsTwitchError}
            setDialog={setDialog}
            authStep={authStep}
            setAuthStep={setAuthStep}
          />
          {/* The library is a pause moment, so it plays earned achievements.
              The world shares this layout but holds them for now. */}
          {pathname !== '/world' && <AchievementDialog />}
        </>
      }
    >
      <Outlet />
    </LibraryLayout>
  );
};

export default LibraryRoute;
